<main class="container py-5">
	<h1 [hidden]="!signedOut">Signed out</h1>
	<h1 [hidden]="!error">Unable to complete sign out</h1>
	<p role="status" [hidden]="signedOut || error">Signing out...</p>
	<button type="button" class="btn btn-primary" [hidden]="!signedOut && !error" (click)="signIn()">Sign in</button>
</main>
